module.exports = __webpack_public_path__ + "static/media/Soundscape2-Restored-Landscape.ff89d568.WAV";